// extracted by mini-css-extract-plugin
export default {"productFeatured":"DX-z","carousel":"EX-z","slides":"FX-z","slide":"GX-z","slideFeatured":"HX-z","zoomMode":"IX-z","fadeIn":"JX-z","imageSizing":"KX-z"};